import OrderStrategy from "./OrderStrategy";

export const DefineByExecutor = OrderStrategy(0,"edi.orders.add_order.order_lifecycle.goods_name_strategy.select.0");
export const DefinedInOrder = OrderStrategy(1, "edi.orders.add_order.order_lifecycle.goods_name_strategy.select.1");